import React, { useEffect, useState, useRef, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { 
  fetchAssetMappings, updateContent, updateMultipleContent, createAssetVersion, uploadingAssetVersionProgress, 
  uploadingAssetVersionStarted, updateFilterSortInContentManager, assetSeekIndexing, fetchAssetMapping 
} from 'actions/content';

import {
  createGatingConfiguration,
  updateGatingConfiguration, deleteGatingConfiguration,
  createGatingConfigurationForMapping, fetchGatingConfigurationsForMapping
} from 'actions/gatingConfigurations';

import { Modal, InputGroup } from 'react-bootstrap';
import _ from 'lodash';
import cx from "classnames";
import styles from './contents.module.scss';
import LinesEllipsis from 'react-lines-ellipsis'
import shortid from 'shortid';
import Selecto from 'react-selecto';
import CreatableSelect from 'react-select/creatable';
import { createMixpanelEvent } from "actions/mixpanel";
import { getStoryboardMixpanelEventPayload } from 'services/mixpanelUtil';
import { MIXPANEL_GATING_CONFIGURED } from 'constants/mixpanelEvents';
import Select, { components } from 'react-select';
import dateformat from "dateformat";
import Truncate from 'react-truncate';

import { Form, Button, Tabs, Tab, Popover, OverlayTrigger, Image, Tooltip, Container, Dropdown } from 'react-bootstrap';

import GatingConfigurations from 'components/gatings';
import { getFieldSelector } from '../../Editor/widgets/content/sectionManager/components';
import { ThumbnailControl } from '../../Editor/widgets/content/sectionManager/components/thumbnailControl';
import ContentConfigCard from '../../Editor/widgets/content/sectionManager/components/contentGatingCard';
import InfiniteScroll from "components/InfiniteScroll";

import { CustomFieldsDropDown, FormHeader, MultiContentCard, SmallContentCard, ContentUrl } from './components';
import { fetchCustomFields } from 'actions/fields/fields';
import { Loader } from 'components/ApplicationLoader';
import { ContentCard } from './components/contentCard';
import { AssetAliases } from './components/aliases';
import { FileUploadButton } from 'components/Buttons';
import { isUrl, fixHTTPUrl } from 'services/asset.service';
import { ReactComponent as MetadataLoader } from 'assets/images/assetVersionloader.svg';
import TruncatedTextWithTooltip from 'components/TruncatedTextWithTooltip';
import FileService from 'services/file.service';

import { filterOptions, sortOptions } from 'constants/filters';
import { guid } from 'services/util';
import { processRequest } from 'services/filters.service';
import { AssetFilter, PropertyContext } from 'components/AssetFilter';
import { Property } from 'components/Editor/components/properties';


const ContentView = ({ editorSession, selection, onSelectionChange, storyboard, multiple=true, onDelete, inline, allowType }) => {
  const dispatch = useDispatch();
  const infiniteScrollRef = useRef(null);
  const [state, setState] = useState({
    arrangeOption: {
      label: 'Name',
      value: 'name'
    }
  })
  const [selectAll, setSelectAll] = useState(false);

  const storyboardType = _.get(storyboard, 'type');
  const contents = useSelector(state => _.get(state, 'content.assets')) || [];
  const contentUpdated = useSelector(state => _.get(state, 'content.updated', false));
  const loading = useSelector(state => _.get(state, 'content.loading', false));
  const pagination = useSelector(state => _.get(state, 'content.pagination', {}));
  const hasMoreItems = _.get(pagination, "currentPage") < _.get(pagination, "totalPages") - 1;
  const empty = _.size(contents) === 0;

  const filters = useSelector(state => _.get(state, `content.assetFilters.filters`));
  const sort = useSelector(state => _.get(state, `content.assetFilters.sort`, 'modified_date'));
  const order = useSelector(state => _.get(state, `content.assetFilters.order`, 'DESC'));

  useEffect(() => {
    handleFetchMappings(0);
  }, [filters, sort, order]);

  const handleFetchMappings = (page) => {
    const requestId = guid();
    
    var commandsRequest = processRequest(filters);
    commandsRequest = (commandsRequest || []).filter(item => item.operator === "IS_ALL" || item.value && item.value.length > 0);

    if(storyboard) {
      var request = {
        storyboard: _.get(storyboard, 'id'),
        sort: sort,
        order: order,
        excludeStoryboardAssets: inline
      }

      if(commandsRequest.length > 0){
        request = {
          ...request,
          commands: commandsRequest
        }
      }

      dispatch(fetchAssetMappings(request, page, 20, requestId));
    }
  }

  useEffect(() => {
    if (!contentUpdated) {
      return
    }
    onSelectionChange([])
  }, [contentUpdated])

  const loadMore = () => {
    const nextPage = pagination.currentPage + 1;
    if (nextPage >= pagination.totalPages) {
      return;
    }
    handleFetchMappings(nextPage);
  }

  const handleAssetClicked = (e, asset) => {

    var multiSelect = false;
    if ((e.metaKey || e.shiftKey || e.ctrlKey) && multiple) {
      multiSelect = true;
    }

    var updated = selection || [];

    var isSelected = updated.some(item => item.id === asset.id);

    if (isSelected && !multiSelect) {
      return;
    }

    if (!isSelected) {
      if (multiSelect) {
        updated = [...updated, asset];
      } else {
        updated = [asset];
      }
    }

    if (isSelected && multiSelect && updated.length > 1) {
      updated = updated.filter(item => item.id !== asset.id);
    }

    onSelectionChange(updated);
  }

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectAll(true)
      return
    }

    setSelectAll(false)
    onSelectionChange([])
  }

  useEffect(() => {
    if (selectAll) {
      onSelectionChange(contents)
    }
  }, [contents, selectAll])

  const handleSelectoSelectEnd = (e) => {
    var selectedContent = _.intersectionBy(contents, e.selected, 'id');
    if (_.size(selectedContent) < 1) {
      return;
    }
    onSelectionChange(selectedContent);
  };

  return (
    <div className={styles.contentWrapperContainer}>
      <div ref={infiniteScrollRef} className={cx(styles.contentViewContainer, { [styles.layoutChange]: _.size(selection) > 0 })}>
      <div className={cx(styles.actionsContainer)}>
          <div className={cx(styles.contentAction)}>
            <span className={styles.contentTitle}>All Content</span>
            <div className={cx(styles.actionsGroup)}>
              <Button variant='info' disabled={_.size(selection) < 1} onClick={onDelete}>
                <i className={cx('cleverstory-trash')} />
              </Button>
              {storyboardType === 'RESOURCE_CENTER' &&
                <SortOrderRender/>
              }
            </div>
          </div>
        </div>
        <div className={styles.filterContentWrapper}>
          <div className={cx(styles.actionsContainer)}>
            {storyboardType === 'RESOURCE_CENTER' &&
              <FilterRenderer inline={inline}/>
            }
          </div>

          <div id='selecto-draggable' className={styles.contentsCardContainer}>
            {(empty && !loading) && renderEmptyMessage()}
            {loading && contents.length === 0 &&
              <div className={styles.loadingAnimationContainer}>
                <Loader className={styles.loadingAnimation} title="Loading..." />
              </div>
            }
            {contents.length > 0 &&
              <InfiniteScroll
                className={cx(styles.scrollable)}
                loading={loading}
                hasMore={hasMoreItems}
                loadMore={loadMore}
              >
                {contents.map((asset, index) => {
                  var selected = selection.some(item => item.id === _.get(asset, 'id', null));
                  return (
                    <ContentCard
                      key={index}
                      id={_.get(asset, 'id', null)}
                      assetMapping={asset}
                      selected={selected}
                      onClick={handleAssetClicked}
                      allowType={allowType}
                    />
                  );
                })}
              </InfiniteScroll>
            }
          </div>
        </div>
        { multiple &&   
        <Selecto
          container={infiniteScrollRef.current}
          selectableTargets={[".cs-asset-card"]}
          selectedTargets={[".cs-selected-asset-card"]}
          selectByClick={false}
          selectFromInside={false}
          toggleContinueSelect={[["ctrl"], ["shift"], ["command"]]}
          preventDragFromInside={false}
          onSelect={(e) => {
            if (
              (_.size(e.selected) < 1)
            ) {
              e.stop();
              return;
            }
            onSelectionChange([])
          }}
          onSelectEnd={handleSelectoSelectEnd}
        ></Selecto>}
      </div>
      <div className={cx(styles.assetDetailEditor, { [styles.expandDetails]: _.size(selection) > 0 })}>
        <EditMapping editorSession={editorSession} contents={selection} storyboard={storyboard} />
      </div>
    </div>
  )
}

const FilterRenderer = ({ inline }) => {
  const dispatch = useDispatch();

  const filters = useSelector(state => _.get(state, `content.assetFilters.filters`) || []);
  const sort = useSelector(state => _.get(state, `content.assetFilters.sort`, 'modified_date'));
  const order = useSelector(state => _.get(state, `content.assetFilters.order`, 'DESC'));

  const customFields = useSelector(state => _.get(state, 'fields.items', []));

  const propertiesOption = useMemo(() => {
    const customFieldProperties = customFields.map(field => {
      return {
        key: `custom_field_${field.id}`,
        value: {
          fieldId: field.id,
          type: 'CUSTOM_FIELD'
        },
        label: field.name,
        data_type: 'list',
        icon: 'list-field',
        config: {
          multiple: true,
          options: (field.options || []).map(option => {
            return {
              value: option.id,
              label: option.value
            }
          })
        }
      }
    })

    return [...filterOptions, ...customFieldProperties];
  })

  useEffect(() => {
    if (filters && filters.length === 0) {
      initiateLayout();
    }
  }, [])

  const initiateLayout = () => {
    var requestFilters = filters || [];

    if (!filters || _.size(filters) <= 0) {
      requestFilters = [...filters, {
        property: {
          type: 'ASSET'
        },
        operator: 'IS'
      }];
    }

    requestFilters = requestFilters.map(item => {
      return {
        ...item,
        id: guid()
      }
    })

    var request = {
      ...filters,
      filters: requestFilters,
      sort: sort,
      order: order
    }

    dispatch(updateFilterSortInContentManager(request));
  }

  const updateFilterChanges = (filterRequests) => {
    var request = {
      filters: filterRequests
    }

    dispatch(updateFilterSortInContentManager(request));
  }

  const insertFilter = () => {
    var request = {
      id: guid(),
      property: {
        type: 'ASSET'
      },
      operator: 'IS'
    }

    var requestFilters = [...filters, request];

    updateFilterChanges(requestFilters);
  }

  const deleteFilter = (index) => {
    var updated = [...filters];
    updated.splice(index, 1);

    updateFilterChanges(updated);
  }

  const onFilterChange = (filter) => {
    var updated = filters.map((item, index) => {
      if (item.id === filter.id) {
        return filter;
      }

      return item;
    });

    updateFilterChanges(updated);
  }

  return (
    <Container fluid className={styles.contentFilterContainer}>
      <PropertyContext.Provider value={propertiesOption}>
        {filters.map((data, index) => {
          return (
            <AssetFilter
              key={index}
              index={index}
              value={data}
              onChange={onFilterChange}
              onInsert={insertFilter}
              onDelete={deleteFilter}
              canDelete={index !== 0}
              showAddFilter={index === (filters.length - 1)}
              inline={inline}
              filters={filters}
            />
          )
        })}
      </PropertyContext.Provider>
    </Container>
  )
}

const SortOrderRender = () => {
  const dispatch = useDispatch();

  const sort = useSelector(state => _.get(state, `content.assetFilters.sort`, 'modified_date'));
  const order = useSelector(state => _.get(state, `content.assetFilters.order`, 'DESC'));

  const sortOption = sortOptions.find(item => item.value === sort);

  const handleSortChange = (sort) => {
    var request = {
      sort: sort
    }
    dispatch(updateFilterSortInContentManager(request));
  }

  const handleOrderChange = (order) => {
    var request = {
      order: order
    }
    dispatch(updateFilterSortInContentManager(request));
  }

  return (
    <div className={styles.sortActionContainer}>
      <div className={styles.conditions}>
        <span className={styles.label}>
          <span>Sort by: </span>
          <img onClick={(e) => handleOrderChange(order === "ASC" ? "DESC" : "ASC")} className={cx(styles.sortIcon, order === "ASC" ? styles.ascending : styles.descending)} alt="sortIcon" src='/images/sortIcon.svg' />
        </span>

        <Dropdown className={styles.sortDropdown} onSelect={handleSortChange}>
          <Dropdown.Toggle className={styles.selected}>
            <Button size='sm' variant='primary' className={styles.button}>
              <span className={styles.filterType}>
                {_.get(sortOption, 'label', '')}
              </span>
              <i className={cx(styles.icon, 'cleverstory-drop-down')} />
            </Button>
          </Dropdown.Toggle>
          <Dropdown.Menu className={styles.typesMenu}>
            {sortOptions.map(item => {
              return <Dropdown.Item
                eventKey={item.value}
                onChange={() => handleSortChange(item.value)}>
                {item.label}
              </Dropdown.Item>
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}

const EditMapping = ({ editorSession, contents, storyboard }) => {
  const dispatch = useDispatch();

  const customFields = useSelector(state => { return _.get(state, 'fields', {}) });

  useEffect(() => {
    if (!storyboard) {
      return;
    }
    dispatch(fetchCustomFields(_.get(storyboard, 'id')))
  }, [storyboard]);

  if (_.size(contents) == 1) {
    const mapping = contents[0];
    const entityType = _.get(mapping, 'entityType');
    if(entityType === 'asset' || entityType === 'page'){
      return <EditSingleAssetContent editorSession={editorSession} content={mapping} storyboard={storyboard} customFields={customFields} />
    }
  }
  else if (_.size(contents) > 1) {
    return <EditMultipleAssetContent content={contents} storyboard={storyboard} customFields={customFields} />
  }
  return false;
}

const EditSingleAssetContent = ({ editorSession, content, storyboard, customFields }) => {
  const dispatch = useDispatch();

  const assetContent = useSelector(state => {
    const assets = _.get(state, `content.assets`) || [];
    let selectedAsset = assets.find(item => item.id === _.get(content, 'id'));
    if (!selectedAsset) {
      return null;
    }
    return selectedAsset
  });

  const assetData = _.get(assetContent, 'asset');
  const tags = _.get(assetContent, 'tags');

  const assetSource = _.get(assetContent, 'source');
  const disableDownload = _.get(assetContent, 'disableDownload', 'true');
  const newTab = _.get(assetContent, 'newTab', true);
  const disableShare = _.get(assetContent, 'disableShare', 'true');
  const excludeFromSearch = _.get(assetContent, 'excludeFromSearch', 'false');
  const seekEnabled = _.get(assetContent, 'seekEnabled', false);
  const seekStatus = _.get(assetContent, 'seekStatus');
  const contentId = _.get(assetContent, "id", null);
  const gatingConfigs = useSelector((state) => _.get(state, `gatingConfigurations.${contentId}.items`, []) || []);
  const contentType = _.get(assetContent, "entityType", null);
  const updating = _.get(assetContent, 'updating');
  const optimizing = _.get(assetContent, 'asset.entityType') === "asset" && _.get(assetContent, 'asset.status') != "OK";
  const loading = updating || optimizing;

  const [activeTab, setActiveTab] = useState('metadata');

  const handlePropertyChange = (data) => {
    const { field, value } = data;

    var requestFields = {
      ...assetContent,
      [field]: value
    }

    dispatch(updateContent(contentId, requestFields))
  }

  const toogleSeekindexing =()=> {
    if(seekStatus == 'PROCESSING' || seekStatus == 'REQUESTED') {
      return;
    }

    const indexingRequest = {
      contentType: contentType,
      content: _.get(assetContent, 'asset.id'),
      contentMapping: _.get(assetContent, 'id'),
      storyboard: _.get(storyboard, 'id'),
      addStoryboard: !seekEnabled
    }

    dispatch(assetSeekIndexing(indexingRequest));
  }

const toggleNewTab = (newTab) => {
  var requestFields = {
    ...assetContent,
    newTab: newTab
  }

  dispatch(updateContent(contentId, requestFields))
};

  const toggleDownload = () => {
    var requestFields = {
      ...assetContent,
      disableDownload: !disableDownload
    }

    dispatch(updateContent(contentId, requestFields))
  }

  const toggleShare = () => {
    var requestFields = {
      ...assetContent,
      disableShare: !disableShare
    }
    dispatch(updateContent(contentId, requestFields))
  }

  const handleResyncAsset =()=> {
    dispatch(fetchAssetMapping(contentId, _.get(storyboard, 'id')))
  }



  const toggleSearch = () => {
    var requestFields = {
      ...assetContent,
      excludeFromSearch: !excludeFromSearch
    }
    dispatch(updateContent(contentId, requestFields))
  }

  useEffect(() => {
    if (contentId) {
      dispatch(fetchGatingConfigurationsForMapping(contentId, storyboard.id, contentType));
    }
  }, [contentId])

  useEffect(() => {
    if (content.entityType === 'page') {
      setActiveTab('metadata')
    }
  }, [content])

  const createNewGating = () => {
    var request = {
      uid: shortid(),
      name: 'Untitled Gating',
      enabled: false,
      optional: false,
      target: {
        type: contentType === "page" ? "page" : "asset",
        id: contentId
      },
      trigger: { type: 'TIME', value: 10 }
    }

    dispatch(createGatingConfiguration(contentId, request));
  }
  const gatingUpdateRef = React.useRef([]);
  const storyboardDetail = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));

  const handleSaveGating = () => {

    let gatingConfigurations = gatingConfigs.filter((item) => item.updated === true).map(item => {
      return {
        ...item,
        gating: _.get(item, 'gating.id', null),
        target: {
          type: contentType === "page" ? "page" : "asset",
          id: _.get(item, "target.id", null)
        }
      }
    });

    dispatch(createGatingConfigurationForMapping(storyboard.id, contentId, gatingConfigurations))
    const triggerTypeMapping = {
      INTERACTIVE_SECTION: "Sections",
      INTERACTIVE_DOWNLOAD: "On Download",
      TIME: "Time",
      PERCENTAGE: "Percentage"
    };
    for (const item of gatingConfigs) {
    const matchingUpdate = gatingUpdateRef.current.find(
    (update) => update.id === item.uid
    );
    if ((matchingUpdate || !item.id) && item.enabled && item.trigger?.value !== "" &&
    !isNaN(item.trigger?.value)) {
    const mixpanelPayload = {
    ...getStoryboardMixpanelEventPayload(
          storyboardDetail.id,
          storyboardDetail.name,
          storyboardDetail.type
    ),
    gating_type: "Asset",
    trigger:
      triggerTypeMapping[_.get(item, "trigger.type", "")] ||
      _.get(item, "trigger.type", ""),
      optional: _.get(item, "optional", ""),
  };
  dispatch(createMixpanelEvent(MIXPANEL_GATING_CONFIGURED, mixpanelPayload));
}}
gatingUpdateRef.current = [];
}

  const handleUpdateGating = (id, request) => {
    gatingUpdateRef.current.push({ id, request });
    dispatch(updateGatingConfiguration(contentId, id, request));
  }

  const handleDeleteGating = (id, gatingConfigId) => {
    dispatch(deleteGatingConfiguration(contentId, id, gatingConfigId))
  }

  const renderTooltip = (text) => (
    <Tooltip className={styles.tabTooltip} id="button-tooltip">{text}</Tooltip>
  );

  return (
    <div className={styles.editorWrapper}>
      <Tabs
        activeKey={activeTab}
        defaultActiveKey={'metadata'}
        className={styles.customEditTabs}
        onSelect={(tab) => setActiveTab(tab)}
        fill
      >
        <Tab
          className={styles.tabDetailForm}
          eventKey="metadata"
          title={
            <OverlayTrigger
              placement="top"
              trigger={["hover", "focus"]}
              overlay={renderTooltip('Metadata')}
            >
              <i className={cx('cleverstory-metadata')} />
            </OverlayTrigger>
          }
        >
          <MetaDataForm
            assetMapping={assetContent}
            source={assetSource}
            seekEnabled={seekEnabled}
            seekStatus={seekStatus}
            newTab={newTab}
            toggleNewTab={toggleNewTab}
            toogleSeekindexing={toogleSeekindexing}
            handleResyncAsset={handleResyncAsset}
            disableDownload={disableDownload}
            disableShare={disableShare}
            toggleDownload={toggleDownload}
            toggleShare={toggleShare}
            excludeFromSearch={excludeFromSearch}
            toggleSearch={toggleSearch}
            handlePropertyChange={handlePropertyChange}
            storyboard={storyboard}
          />
        </Tab>
        <Tab
          className={styles.tabDetailForm}
          eventKey="tags"
          disabled={loading}
          title={
            <OverlayTrigger
              placement="top"
              trigger={["hover", "focus"]}
              overlay={renderTooltip('Tags')}
            >
              <i className={cx('cleverstory-tag')} />
            </OverlayTrigger>
          }
        >
          <TagsDataForm
            content={assetContent}
            handlePropertyChange={handlePropertyChange}
            multiple={true}
          />
        </Tab>
        {storyboard.type === 'RESOURCE_CENTER' &&
          <Tab
            className={styles.tabDetailForm}
            eventKey="custom-fields"
            disabled={loading}
            title={
              <OverlayTrigger
                placement="top"
                trigger={["hover", "focus"]}
                overlay={renderTooltip('Custom Fields')}
              >
                <i className={cx('cleverstory-fields')} />
              </OverlayTrigger>
            }
          >
            <CustomFieldsForm
              content={assetContent}
              customFields={customFields}
              handlePropertyChange={handlePropertyChange}
            />
          </Tab>
        }

        {(content.entityType === "asset" && storyboard.type !== 'SPATIAL') &&
          <Tab
            className={styles.tabDetailForm}
            eventKey="gating"
            title={
              <OverlayTrigger
                placement="top"
                trigger={["hover", "focus"]}
                overlay={renderTooltip('Gating')}
              >
                <i className={cx('cleverstory-lock')} />
              </OverlayTrigger>
            }
          >
            <GatingConfigForm
              key={contentId}
              content={assetContent}
              gatingConfigs={gatingConfigs}
              handleSaveGating={handleSaveGating}
              createNewGating={createNewGating}
              handleUpdateGating={handleUpdateGating}
              handleDeleteGating={handleDeleteGating}
            />
          </Tab>
        }
        {content.entityType === "asset" && storyboard.type !== 'SPATIAL' &&
          <Tab
            className={styles.tabDetailForm}
            eventKey="aliases"
            title={
              <OverlayTrigger
                placement="top"
                trigger={["hover", "focus"]}
                overlay={renderTooltip('Aliases')}
              >
                <i className={cx('cleverstory-link')} />
              </OverlayTrigger>
            }
          >
            <AssetAliases editorSession={editorSession} content={assetContent} />
          </Tab>
        }

        {/* <Tab eventKey="seo" title={<i className={cx('cleverstory-web')} />}>
          <SEOConfigForm content={content} />
        </Tab>
        <Tab eventKey="analytics" title={<i className={cx('cleverstory-trendline')} />}>
          <AnalyticsForm content={content} />
        </Tab> */}
      </Tabs>
    </div>
  )
}

const EditMultipleAssetContent = ({ content, storyboard, customFields }) => {
  const dispatch = useDispatch();
  const contentId = _.get(content, "id", null);
  const contentType = _.get(content, "entityType", null);
  const gatingConfigs = useSelector((state) => _.get(state, `gatingConfigurations.${contentId}.items`, []) || []);

  const [multipleContent, setMultipleAssetContent] = useState({
    summary: '',
    tags: [],
    customFields: [],
    disableDownload: true,
    excludeFromSearch: false,
    disableShare: true,
    gatingConfigurations: []
  });
  const selectedId = _.map(content, (data) => {
    return data.id;
  })

  const handleMultipleChange = (data) => {
    const { field, value, addedTags, removedTags, addedValues, removedValues, action, multiSelect, fieldId } = data;
    
    if (field === 'tags') {
      setMultipleAssetContent((state) => {
        const currentTags = _.get(state, 'tags') || [];
        let newTags;
        
        if (action === 'remove' && removedTags.length > 0) {
          newTags = currentTags.filter(tag => !removedTags.includes(tag));
        } else if (action === 'add' && addedTags.length > 0) {
          newTags = _.uniq([...currentTags, ...addedTags]);
        } else {
          newTags = Array.isArray(value) ? value : currentTags;
        }
        
        return {
          ...state,
          [field]: newTags
        }
      });
    } else if (field === 'customFields') {
      setMultipleAssetContent((state) => {
        const currentCustomFields = _.get(state, 'customFields') || [];
        let updatedCustomFields = [...currentCustomFields];
        
        const fieldIndex = updatedCustomFields.findIndex(cf => cf.id === fieldId);
        
        if (fieldIndex !== -1) {
          const currentFieldValues = updatedCustomFields[fieldIndex].value || [];
          let newFieldValues;
          
          if (action === 'remove' && removedValues.length > 0) {
            newFieldValues = currentFieldValues.filter(val => 
              !removedValues.some(removedVal => removedVal.id === val.id)
            );
          } else if (action === 'add' && addedValues.length > 0) {
            newFieldValues = _.uniqBy([...currentFieldValues, ...addedValues], 'id');
          } else {
            newFieldValues = value.find(cf => cf.id === fieldId)?.value || [];
          }
          
          if (newFieldValues.length > 0) {
            updatedCustomFields[fieldIndex] = {
              ...updatedCustomFields[fieldIndex],
              value: newFieldValues
            };
          } else {
            updatedCustomFields.splice(fieldIndex, 1);
          }
        } else if (action === 'add' && addedValues.length > 0) {
          const newField = value.find(cf => cf.id === fieldId);
          if (newField) {
            updatedCustomFields.push(newField);
          }
        }
        
        return {
          ...state,
          customFields: updatedCustomFields
        }
      });
    } else {
      setMultipleAssetContent((state) => {
        return {
          ...state,
          [field]: value
        }
      });
    }
    
    dispatch(updateMultipleContent(selectedId, field, data, multiSelect));
  }

  const createNewGating = () => {
    var request = {
      uid: shortid(),
      name: 'Untitled Gating',
      enabled: false,
      optional: false,
      target: {
        type: contentType === "page" ? "page" : "asset",
        id: contentId
      },
      trigger: { type: 'TIME', value: 10 }
    }

    setMultipleAssetContent((state) => {
      return {
        ...state,
        gatingConfigurations: [
          ...state.gatingConfigurations,
          request
        ]
      }
    })
    _.forEach(content, (data) => {
        dispatch(createGatingConfiguration(contentId, request));
    })
  }

  const handleSaveGating = () => {
    let gatingConfigurations = gatingConfigs.filter((item) => item.updated === true).map(item => {
      return {
        ...item,
        gating: _.get(item, 'gating.id', null),
        target: {
          type: contentType === "page" ? "page" : "asset",
          id: _.get(item, "target.id", null)
        }
      }
    })

    dispatch(createGatingConfigurationForMapping(storyboard.id, contentId, gatingConfigurations))
  }

  const handleUpdateGating = (id, request) => {
    updateMultipleContentGating(id, request);

    _.forEach(content, (data) => {
      dispatch(updateGatingConfiguration(data.id, id, request));
    })
  }

  const handleDeleteGating = (id) => {
    setMultipleAssetContent((state) => {
      return {
        ...state,
        gatingConfigurations: _.filter(state.gatingConfigurations, (gating) => { return gating.uid !== id })
      }
    })

    _.forEach(content, (data) => {
      dispatch(deleteGatingConfiguration(data.id, id));
    })
  }

  const updateMultipleContentGating = (id, request) => {
    const updatedGating = _.map(multipleContent.gatingConfigurations, (gating) => {
      if (gating.uid === id) {
        return {
          ...gating,
          ...request
        }
      }
      return gating;
    })

    setMultipleAssetContent((state) => {
      return {
        ...state,
        gatingConfigurations: updatedGating
      }
    })
  }

  return (
    <div className={styles.editorWrapper}>
      <Tabs
        defaultActiveKey="metadata"
        className={styles.customEditTabs}
        fill
      >
        <Tab className={styles.tabDetailForm} eventKey="metadata" title={<i className={cx('cleverstory-metadata')} />}>
          <MultipleMetaDataForm
            content={multipleContent}
            handlePropertyChange={handleMultipleChange}
            disableDownload={multipleContent.disableDownload}
            disableShare={multipleContent.disableShare}
            excludeFromSearch={multipleContent.excludeFromSearch}
          />
        </Tab>
        <Tab className={styles.tabDetailForm} eventKey="tags" title={<i className={cx('cleverstory-tag')} />}>
          <TagsDataForm
            content={multipleContent}
            multiple={true}
            handlePropertyChange={handleMultipleChange}
          />
        </Tab>
        {storyboard.type === 'RESOURCE_CENTER' &&
          <Tab className={styles.tabDetailForm} eventKey="custom-fields" title={<i className={cx('cleverstory-fields')} />}>
            <CustomFieldsForm
              content={multipleContent}
              multiple={true}
              customFields={customFields}
              handlePropertyChange={handleMultipleChange}
            />
          </Tab>
        }

        {content.entityType === "asset" &&
          <Tab className={styles.tabDetailForm} eventKey="gating" title={<i className={cx('cleverstory-lock')} />}>
            <GatingConfigForm
              content={multipleContent}
              multiple={true}
              gatingConfigs={multipleContent.gatingConfigurations}
              handleSaveGating={handleSaveGating}
              createNewGating={createNewGating}
              handleUpdateGating={handleUpdateGating}
              handleDeleteGating={handleDeleteGating}
            />
          </Tab>
        }

        {/* <Tab eventKey="seo" title={<i className={cx('cleverstory-web')} />}>
          <SEOConfigForm content={content} />
        </Tab>
        <Tab eventKey="analytics" title={<i className={cx('cleverstory-trendline')} />}>
          <AnalyticsForm content={content} />
        </Tab> */}
      </Tabs>
    </div>
  )
}

const MultipleMetaDataForm = ({ content, disableDownload, excludeFromSearch, disableShare, handlePropertyChange }) => {
  var description = _.get(content, 'summary', "");

  const handleFieldChange = (fieldName, value) => {

    const requestMeta = {
      field: fieldName,
      value: value
    }

    handlePropertyChange(requestMeta)
  }

  return (
    <div className={styles.detailFormContainer}>
      <FormHeader
        title={'Metadata'}
        discription={'Metadata refers to descriptive information about a piece of data or content.'}
      />

      <div className={styles.multiAssetOverview}>
        <div className={styles.iconContainer}>
          <Image src={`${process.env.REACT_APP_UI_URL}/images/multidoc.svg`} className={styles.docIcon} />
        </div>
        <div className={styles.infoContainer}>
          <div className={styles.asset}>
            <span className={styles.title}>Multiple Asset</span>
            <span className={styles.secondary}>{`Type:<Multiple>`}</span>
          </div>
          <div className={styles.publish}>
            <span className={styles.secondary}>{`Publish:<Multiple>`}</span>
            <span className={styles.secondary}>{`Updated:<Multiple>`}</span>
          </div>
        </div>
      </div>
      <div className={styles.formWrapper}>
        <Form.Group className={styles.inputFields}>
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            disabled
            placeholder="-NA-"
          />
        </Form.Group>
        <Form.Group className={styles.inputFields}>
          <Form.Label>Description</Form.Label>
          <Form.Control
            as="textarea"
            placeholder='Mixed Description'
            value={description}
            rows={1}
            onChange={(e) => {
              handleFieldChange('summary', e.target.value)
            }}
          />
        </Form.Group>
        <hr></hr>
        <div className={styles.downloadWrapper}>
          <span>Download</span> 

          <Form.Switch className={cx(styles.downloadSwitch, styles.mixedDownload)}>
            <Form.Switch.Label className={styles.label2}>Mixed</Form.Switch.Label>
            <Form.Switch.Input onClick={() => { handleFieldChange('disableDownload', !disableDownload) }} className={styles.toggleButton} checked={!disableDownload} />
          </Form.Switch>
        </div>

        <hr></hr>
        
        <div>
        <Form.Switch className={cx(styles.downloadSwitch)}>
            <Form.Switch.Label className={styles.label}>Exclude From Search</Form.Switch.Label>
            <Form.Switch.Input onClick={() => { handleFieldChange('excludeFromSearch', !excludeFromSearch) }} className={styles.toggleButton} checked={excludeFromSearch} />
        </Form.Switch>
        </div>

        <hr></hr>

        <div className={styles.downloadWrapper}>
          <span>Share</span> 

          <Form.Switch className={cx(styles.downloadSwitch, styles.mixedDownload)}>
            <Form.Switch.Label className={styles.label2}>Mixed</Form.Switch.Label>
            <Form.Switch.Input onClick={() => { handleFieldChange('disableShare', !disableShare) }} className={styles.toggleButton} checked={!disableShare} />
          </Form.Switch>
        </div>
      </div>
    </div>
  )
}


const MetaDataForm = React.memo(({ assetMapping, source, disableDownload, disableShare,  excludeFromSearch, seekEnabled, seekStatus, newTab, handlePropertyChange, handleResyncAsset, toggleNewTab, toogleSeekindexing, toggleDownload, toggleSearch, toggleShare, storyboard }) => {

  const content = _.get(assetMapping, 'asset');
  const viewer = _.get(content, 'viewer.mode', "");
  const viewerMode = _.get(content, 'viewerMode');

  var name = _.get(content, 'name', "");
  var icon = _.get(content, 'icon');
  var description = _.get(content, 'summary', "");
  const entityType = _.get(content, 'entityType', null);

  const contentId = _.get(content, "id", null);

  const isSourcePf = source && (source.toLowerCase() === 'paperflite') ? true : false;
  const contentType = _.get(content, "metadata.content_type")
  const seekEnabledWorkspace = useSelector(state => { return _.get(state, 'workspaces.workspace.item.seekSettings.seekEnabled', false) });
  const updating = _.get(assetMapping, 'updating');
  const optimizing = _.get(assetMapping, 'asset.entityType') === "asset" && _.get(assetMapping, 'asset.status') != "OK";
  const loading = updating || optimizing;

  const modifiedDate = _.get(assetMapping, 'modifiedDate') || _.get(content, 'metadata.modified_date');

  const uploadIconRef = React.createRef();
  const assetFileType = FileService.fileType(_.get(content, 'metadata', {}));
  const sourceType = _.get(content, 'metadata.source_type', null);

  const customOptions = [{"value": "render_in_viewer", "label": "Render in viewer"},
  {"value": "render_optimized_view", "label": "Render optimized view"},
  {"value": "open_in_new_tab", "label": "Open in new tab"}
]

const mode = viewer ? (viewerMode || viewer) : viewerMode;

var selectedOption = customOptions.find(option => option.value === mode);

  const handleFieldChange = (fieldName, value) => {

    const requestMeta = {
      field: 'asset',
      value: {
        ...content,
        [fieldName]: value
      }
    }

    handlePropertyChange(requestMeta)
  }

  const handleSelect = (value) => {
    if (!value) {
      return;
    }

    selectedOption = value;
    handleFieldChange("viewerMode", value.value)
  }

  const [showModal, setShowModal] = useState(false);

  const handleUploadNewVersionClick = () => {
    setShowModal(true);
  }

  const handleClose = () => {
    setShowModal(false);
  }

  const removeHtmlTags = (htmlString) => {
    if(!htmlString) {
      return ""
    }
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || "";
  };

  const seekActivation =()=> {
    switch (true) {
      case (seekEnabled || (seekStatus == 'PROCESSING' || seekStatus == 'REQUESTED')):
        return true;
    
      case (!seekEnabled && (seekStatus == 'COMPLETED' || seekStatus == null)):
        return false;
    }
  }

  const popover = (
    <Popover key={contentId} bsPrefix="popover" className={styles.overlayOption}>
      <Popover.Body className={styles.overlayOptionBody}>
        <div className={styles.overlayOptionContent}>
          <span onClick={handleUploadNewVersionClick}>
            {contentType !== "application/url" && 
              <ComputerUpload uploadIconRef={uploadIconRef} content={content} />
            }
            <i className={cx("cleverstory-upload")}/>Upload New Version
          </span>
        </div>
      </Popover.Body>
    </Popover>
  );

  return (
    <div className={styles.detailFormContainer}>
      <FormHeader
        title={'Metadata'}
        discription={'Metadata refers to descriptive information about a piece of data or content.'}
      />

      {!loading &&
        <>
          <div className={styles.assetOverview}>
            <ThumbnailControl
              value={icon}
              disable={isSourcePf}
              onChange={(image) => {
                handleFieldChange('icon', image);
              }}
            />
            <div className={styles.details}>
              <div className={styles.assetInfo}>
                <span className={styles.title}>
                  <Truncate style={{ display: "block" }} lines={1}>
                    {name}
                  </Truncate>
                </span>
                <ContentUrl className={styles.metaWrapper} content={content} />
              </div>
              <div className={styles.publishWrapper}>
                <div className={styles.info}>
                  <span className={styles.text}>
                    Publisher: {entityType != null && entityType === "page" ? `${_.get(content, 'createdBy.firstName', "")} ${_.get(content, 'createdBy.lastName', "")}` : `${_.get(content, 'author.firstName', "")} ${_.get(content, 'author.lastName', "")}`}
                  </span>
                  <span className={styles.text}>
                    Updated: {dateformat(modifiedDate, "dd mmm yyyy")}
                  </span>
                </div>

                {!isSourcePf &&
                  entityType != null &&
                  entityType != "page" && (
                  <>
                    <OverlayTrigger
                      rootClose={true}
                      rootCloseEvent="mousedown"
                      key={contentId}
                      trigger="click"
                      placement="bottom"
                      overlay={popover}
                    >
                      <i
                        className={cx("cleverstory-more", styles.iconMore)}
                      />
                    </OverlayTrigger>
                    {contentType === "application/url" && (
                      <LinkUploadModal
                        show={showModal}
                        content={content}
                        onClose={handleClose}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={styles.formWrapper}>
            <Form.Group className={styles.inputFields}>
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                value={name}
                placeholder="Name"
                disabled={isSourcePf}
                key={contentId}
                onChange={(e) => {
                  handleFieldChange("name", e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group className={styles.inputFields}>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                disabled={isSourcePf}
                key={contentId}
                value={removeHtmlTags(description)}
                rows={3}
                onChange={(e) => {
                  handleFieldChange("summary", e.target.value);
                }}
              />
            </Form.Group>
            {assetFileType === "LINK" && sourceType !== "PDF" &&
              <Form.Group className={styles.inputFields}>
                <Form.Label>Viewer Mode</Form.Label>
                <Select
                  placeholder="None"
                  className={styles.dropdownViewerModeContainer}
                  key={contentId}
                  isClearable={false}
                  onChange={handleSelect}
                  value={selectedOption || ''}
                  options={customOptions}
                  isDisabled={isSourcePf}
                />
              </Form.Group>
            }

            {(entityType!=null && entityType == 'page') && (
            <Property name="Open in" nameStyle={styles.newTabName} className={styles.newTab}>
              <div className={styles.radioGroup}>
                <Property.RadioButton 
                  className={cx(styles.radioOption, {[styles.emptyNewTab]: newTab === false})}
                  title="New in tab"
                  value={newTab === true}
                  onClick={() => toggleNewTab(true)}
                />
                <Property.RadioButton className={cx(styles.radioOption, {[styles.emptyNewTab]: newTab === true})}
                  title="Current"
                  value={newTab === false}
                  onClick={() => toggleNewTab(false)}
                />
              </div>
            </Property>
            )}

            {seekEnabledWorkspace && (
              <>
                <hr></hr>
                <Form.Switch className={cx(styles.downloadSwitch)}>
                  <Form.Switch.Label className={styles.label}>
                    Index for Seek
                  </Form.Switch.Label>
                  {(seekStatus == "PROCESSING" ||
                    seekStatus == "REQUESTED") && (
                      <div className={styles.loader}>
                        <span className={styles.text}>Indexing...</span>
                        <Button onClick={handleResyncAsset} variant="info">
                          <i className={cx("cleverstory-sync")} />
                        </Button>
                      </div>
                    )}
                  <Form.Switch.Input
                    disabled={
                      seekStatus == "PROCESSING" || seekStatus == "REQUESTED"
                    }
                    onMouseDown={toogleSeekindexing}
                    checked={seekActivation()}
                    className={styles.toggleButton}
                  />
                </Form.Switch>
              </>
            )}
            {contentType!="application/url" &&
            <hr></hr>
            }
            {(entityType != null) && (entityType != "page" && contentType != "application/url")
            &&
            (
              <>
              <Form.Switch className={cx(styles.downloadSwitch)}>
                <Form.Switch.Label className={styles.label}>Exclude From Search</Form.Switch.Label>
                <Form.Switch.Input onClick={toggleSearch} className={styles.toggleButton} checked={excludeFromSearch} />
              </Form.Switch>  
              <hr></hr>
              </>
            )
            }
            {contentType!="application/url" &&
            <Form.Switch className={cx(styles.downloadSwitch)}>
              <Form.Switch.Label className={styles.label}>
                Download
              </Form.Switch.Label>
              <Form.Switch.Input
                onClick={toggleDownload}
                className={styles.toggleButton}
                checked={!disableDownload}
              />
            </Form.Switch>
            }
            <hr></hr>

            <Form.Switch className={cx(styles.downloadSwitch)}>
              <Form.Switch.Label className={styles.label}>
                Share
              </Form.Switch.Label>
              <Form.Switch.Input
                onClick={toggleShare}
                className={styles.toggleButton}
                checked={!disableShare}
              />
            </Form.Switch>
          </div>
        </>
      }

      {loading &&
        <CardLoader/>
      }

    </div>
  )
})

const CardLoader = (props) => {
  return(
    <div className={styles.cardLoader}>
        <MetadataLoader/>
    </div>
  )
}

const ComputerUpload = ({ uploadIconRef, content }) => {
  const dispatch = useDispatch();

  const contentId = _.get(content, "id", null);

  const handleContentUploadFinish = (info, file) => {
    if (info) {
      dispatch(createAssetVersion(contentId, info.signedUrl, false));
    }
  }
  
  const handleContentUploadProgress = (file, progress) => {
    dispatch(uploadingAssetVersionProgress(file, progress, contentId));
  }

  const handleUploadStart = (instances) => {
    instances.forEach(instance => {
      const upload = {
        id: instance.files[0].id,
        type: instance.files[0].type,
        progress: 0,
        instance: instance
      }

      dispatch(uploadingAssetVersionStarted(contentId, instance.files[0]));
    });
  }

  return (
    <FileUploadButton
      className={cx(styles.fileUpload)}
      name="Upload new version"
      multiple={false}
      onStart={handleUploadStart}
      onProgress={handleContentUploadProgress}
      onComplete={handleContentUploadFinish}
      limit={3000}
    />
  )
}

const LinkUploadModal = ({ content, show, onClose }) => {
  return (
    <Modal show={show} className={styles.assetUploaderContainer} backdropClassName={styles.backdrop} centered>
      <div className={styles.header}>
        <h1 className={styles.title}>Upload Content</h1>
        <div className={styles.actionContainer}>
          <Button variant='info' onClick={onClose} className={styles.closeButton}>
            <i className={cx('cleverstory-close', styles.closeButtonIcon)} />
          </Button>
        </div>
      </div>
      <div className={styles.body}>
        <ExternalUrlRender content={content} onClose={onClose} />
      </div>
    </Modal>
  )
}

const ExternalUrlRender = ({ content, onClose }) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState("");
  const [error, setError] = useState(null);
  const contentId = _.get(content, "id", null);

  const urlContents = [];

  const handleChange = (e) => {
    setValue(e.target.value);
  }

  const handleAddAssetFromUrl = () => {
    var fixedUrl = fixHTTPUrl(value);

    if (!isUrl(fixedUrl)) {
      setError('Please provide a valid url');
      return;
    } else {
      setError(null);
    }

    dispatch(createAssetVersion(contentId, fixedUrl, true));
    onClose();
    setValue("");
  }

  return (
    <div className={cx(styles.urlRender, { [styles.emptyUrlWrapper]: _.size(urlContents) == 0 })}>
      <div className={cx(styles.urlActionContainer, { [styles.transitionContainer]: _.size(urlContents) > 0 })}>
        <span className={styles.label} >Import assets from a URL</span>
        <InputGroup className={styles.inputContainer}>
          <Form.Control
            onChange={handleChange}
            value={value}
            className={styles.inputField}
            type="text"
            placeholder='Paste your URL here'
          />
          {value &&
            <Button onClick={handleAddAssetFromUrl} variant="primary" className={styles.importButton} id="button-addon">
              Import
            </Button>
          }
          {error &&
            <Form.Control.Feedback className={styles.errorValidation} type="invalid">
              {error}
            </Form.Control.Feedback>
          }
        </InputGroup>
      </div>
    </div>
  )
}

const TagsDataForm = ({ content, multiple, handlePropertyChange }) => {
  let contentTags = _.map((_.get(content, 'tags') || []), (tag) => {
    return {
      value: tag,
      label: tag
    }
  });
  const assetData = _.get(content, 'asset');

  const handleTagChange = (tags) => {
    const currentTags = _.map((_.get(content, 'tags') || []), (tag) => tag);
    const newTags = tags ? _.map(tags, (data) => data.value.toLowerCase()) : [];
    
    const removedTags = currentTags.filter(tag => !newTags.includes(tag));
    
    const addedTags = newTags.filter(tag => !currentTags.includes(tag));
    
    var requestTags = {};

    if (multiple) {
      requestTags = {
        field: 'tags',
        value: newTags,
        addedTags: addedTags,
        removedTags: removedTags,
        action: removedTags.length > 0 ? 'remove' : 'add',
        multiSelect: true
      }
    } else {
      requestTags = {
        field: 'asset',
        value: {
          ...assetData,
          tags: newTags
        },
        addedTags: addedTags,
        removedTags: removedTags,
        action: removedTags.length > 0 ? 'remove' : 'add'
      }
    }

    handlePropertyChange(requestTags)
  } 

  const RemoveIcon = (props) => {
    return (
      <components.MultiValueRemove {...props}>
        <i className={cx(styles.closeIcon, 'cleverstory-close')} />
      </components.MultiValueRemove>
    );
  };

  return (
    <div className={styles.detailFormContainer}>
      <FormHeader
        title={'Tags'}
        discription={'Labels or keywords for categorising & organising your content.'}
      />
      {!multiple && <SmallContentCard content={content} />}
      {multiple && <MultiContentCard />}

      <Form.Group className={styles.inputFields}>
        <Form.Label>Your Tags</Form.Label>
        <CreatableSelect
          className={styles.tagsFields}
          isClearable={false}
          components={{ MultiValueRemove: RemoveIcon }}
          placeholder="Type the tag"
          isMulti
          value={contentTags}
          onChange={handleTagChange}
          options={[]}
        />
      </Form.Group>

      {/* <div className={styles.renderTagsContainer}>
        <div className={styles.header}>
          <span className={styles.title}>Recomended Tags</span>
          <span className={styles.discription}>Here are a few suggested tags to choose from.</span>
        </div>
        <div className={styles.tagWrapper}>
          {
            contentTags.map((data, index) => {
              return (
                <div className={styles.tags}>
                  <span key={index} className={styles.tagText}>
                    <Truncate lines={1}>{data}</Truncate>
                  </span>
                  <i onClick={() => { handleDelete(data) }} className={cx('cleverstory-close', styles.deleteIcon)} />
                </div>
              )
            })
          }
        </div>
      </div> */}
    </div>
  )
}

const CustomFieldsForm = ({ content, customFields, multiple, handlePropertyChange }) => {
  const loading = _.get(customFields, 'loading');
  const fieldsList = _.get(customFields, 'items') || [];
  let contentCustomFields = _.get(content, 'customFields') || []
  const assetMetaData = _.get(content, 'asset');

  const handleOnChange = (field, value) => {
    var values = [];
    if (!field.multiselect && value) {
      values.push(value);
    } else {
      values = value;
    }

    values = values && values.map(item => {
      return field.options.find(option => {
        return option.id === item.id;
      })
    }).filter(item => item != null);

    let selectedFieldIndex = (contentCustomFields || []).findIndex(assetField => {
      return assetField.id === field.id;
    });

    const currentValues = selectedFieldIndex !== -1 ? contentCustomFields[selectedFieldIndex].value || [] : [];
    const newValues = values || [];
    
    const addedValues = newValues.filter(newVal => 
      !currentValues.some(currentVal => currentVal.id === newVal.id)
    );
    const removedValues = currentValues.filter(currentVal => 
      !newValues.some(newVal => newVal.id === currentVal.id)
    );

    if (selectedFieldIndex === -1) {
      let selectedField = {
        id: field.id,
        name: field.name,
        value: values
      }

      contentCustomFields.push(selectedField);
    } else {
      contentCustomFields = contentCustomFields.map(assetField => {
        if (assetField.id === field.id) {
          return {
            ...assetField,
            value: values
          }
        }

        return assetField;
      })
    }

    contentCustomFields = contentCustomFields.filter(item => {
      return !_.isEmpty(item.value);
    });

    const requestFields = {
      field: 'customFields',
      value: contentCustomFields,
      fieldId: field.id,
      addedValues: addedValues,
      removedValues: removedValues,
      action: removedValues.length > 0 ? 'remove' : 'add',
      multiSelect: _.get(field, 'multiselect')
    }

    handlePropertyChange(requestFields)
  }

  return (
    <div className={styles.detailFormContainer}>
      <FormHeader
        title={'Custom Fields'}
        discription={'Additional user-defined data fields for specific information collection.'}
      />
      {!multiple && <SmallContentCard content={assetMetaData} />}
      {multiple && <MultiContentCard />}
      <div className={styles.customFieldRenderer}>
        {!loading && _.size(fieldsList) >= 1 &&
          fieldsList.map((field) => {
            const selectedFieldValue = _.find(contentCustomFields, (data) => { return data.id === field.id });
            return (
              <Form.Group key={field.id} className={styles.customFields}>
                <Form.Label>
                  <i className={cx(styles.icon, 'cleverstory-list-field')} />
                  <TruncatedTextWithTooltip content={field.name} maxWidth={240} placement='top'/>
                </Form.Label>
                <CustomFieldsDropDown customFieldValue={selectedFieldValue} field={field} handleOnChange={handleOnChange} />
              </Form.Group>
            )
          })
        }
      </div>
    </div>
  )
}

const GatingConfigForm = ({ content, gatingConfigs, multiple, createNewGating, handleSaveGating, handleUpdateGating, handleDeleteGating }) => {

  const contentId = _.get(content, "id", null);
  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard"));
  const assetMetaData = _.get(content, 'asset');
  // const mapUpdating = useSelector((state) => _.get(state, "content.mapping.loading"));
  const creating = useSelector((state) => _.get(state, `gatingConfigurations.${contentId}.creating`, false));

  return (
    <>
      <div key={contentId} className={cx(styles.detailFormContainer, styles.gatingDetailFormContainer)}>
        <div className={cx(styles.gatingHeader)}>
          <div className={styles.actionContainer}>
            <span className={styles.title} >Gating</span>
            <Button size='sm' onClick={createNewGating} className={styles.addGatingButton} variant='secondary'>
              <i className={cx(styles.icon, 'cleverstory-plus')} />
              New Gating
            </Button>
          </div>
          <span className={styles.discription} >Additional user-defined data fields for specific information collection.</span>
        </div>

        {!multiple && <SmallContentCard content={assetMetaData} />}
        {multiple && <MultiContentCard />}
        <div key={contentId} className={styles.gatingFromRenderer}>
          {
            gatingConfigs.map((gatingConfig, index) => {
              return (
                <GatingConfigurations index={index}
                  gatingLength={gatingConfigs.length}
                  gatingConfig={gatingConfig}
                  storyboard={storyboard}
                  onUpdate={handleUpdateGating}
                  onDelete={handleDeleteGating}
                  type={"asset"} />
              )
            })
          }
        </div>
      </div>
      <div className={cx(styles.saveGatingContainer)}>
        <Button size="sm" variant="primary" onClick={handleSaveGating}>
          {creating ? "Saving ..." : "Save Gating"}
        </Button>
      </div>
    </>
  )
}

const SEOConfigForm = () => {

  return (
    <div className={styles.detailFormContainer}>
      <FormHeader
        title={'SEO'}
        discription={'Additional user-defined data fields for specific information collection.'}
      />
    </div>
  )
}

const AnalyticsForm = () => {

  return (
    <div className={styles.detailFormContainer}>
      <FormHeader
        title={'Analytics'}
        discription={'Additional user-defined data fields for specific information collection.'}
      />

    </div>
  )
}

const EditSectionContent = ({ mapping, onChange }) => {
  const [gatingSetting, setGatingSetting] = useState(false);

  var name = _.get(mapping, 'asset.name') || "";
  var icon = _.get(mapping, 'asset.icon');
  var description = _.get(mapping, 'asset.description') || "";
  const mappingId = _.get(mapping, "id", null);

  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard"));
  const gatingConfigs = useSelector((state) => _.get(state, `gatingConfigurations.${mappingId}.items`, []) || []);
  const mapUpdating = useSelector((state) => _.get(state, "content.mapping.loading"));



  const dispatch = useDispatch();

  const handleSaveGating = () => {
    const assetMappingId = _.get(mapping, "content.id", null);

    let gatingConfigurations = gatingConfigs.map(item => {
      return {
        ...item,
        gating: _.get(item, 'gating.id', null),
        target: {
          type: "asset",
          id: _.get(item, "target.id", null)
        }
      }
    })

    // dispatch(updateAssetMapping(assetMappingId, { gatingConfigurations: gatingConfigurations }))
  }

  const handleFieldChange = (fieldName, value) => {
    const field = getFieldSelector(mapping, fieldName);
    if (!field) {
      return;
    }

    const request = {
      ...field,
      override: true,
      content: value
    }

    onChange(mapping, request);
  }

  const handleUpdateGating = (id, request) => {
    // dispatch(updateGatingConfiguration(mappingId, id, request))
  }

  const handleDeleteGating = (id) => {
    // dispatch(deleteGatingConfiguration(mappingId, id))
  }


  return (
    <div className={styles.editMapping}>
      <GatingActionCard name={name} icon={icon} mapping={mapping} onChange={onChange} gatingSetting={gatingSetting} setGatingSetting={setGatingSetting} gatingConfigs={gatingConfigs} />
      {!gatingSetting &&
        <div className={cx(styles.assetEditor, { [styles.showEditor]: !gatingSetting })}>
          <div className={styles.header}>
            <span className={styles.name}>
              {mapping && 
                <LinesEllipsis
                  basedOn="words"
                  text={`Original Asset: ${_.get(mapping, 'content.asset.name') || ' '}`}
                  maxLine='1'
                  ellipsis='...'
              />
              }
            </span>
          </div>
          <div className={styles.body}>
            <Form className={styles.form}>
              <Form.Group className={styles.field}>
                <ThumbnailControl
                  value={icon}
                  onChange={(image) => {
                    handleFieldChange('icon', image);
                  }}
                />
              </Form.Group>
              <Form.Group className={styles.field}>
                <Form.Label className={styles.label}>
                  Name
                </Form.Label>
                <Form.Control
                  className={styles.control}
                  name="name"
                  value={name}
                  onChange={(e) => {
                    handleFieldChange('name', e.target.value)
                  }}
                />
              </Form.Group>
              <Form.Group className={styles.field}>
                <Form.Label className={styles.label}>
                  Description
                </Form.Label>
                <Form.Control
                  as="textarea" rows={4}
                  className={styles.control}
                  name="description"
                  value={description}
                  onChange={(e) => {
                    handleFieldChange('description', e.target.value)
                  }}
                />
              </Form.Group>
            </Form>
          </div>
        </div>}
      {gatingSetting &&
        <div className={cx(styles.gatingRegistration, { [styles.showEditor]: gatingSetting })}>
          {
            gatingConfigs.map((gatingConfig, index) => {
              return (
                <GatingConfigurations index={index}
                  gatingLength={gatingConfigs.length}
                  gatingConfig={gatingConfig}
                  storyboard={storyboard}
                  onUpdate={handleUpdateGating}
                  onDelete={handleDeleteGating}
                  type={"asset"} />
              )
            })
          }

        </div>
      }
      {gatingSetting &&
        <div className={cx(styles.saveGatingContainer)}>
          <Button size="sm" variant="primary" onClick={handleSaveGating}>
            {mapUpdating ? "Saving ..." : "Save Gating"}
          </Button>
        </div>}
    </div>
  );
}


const GatingActionCard = ({ icon, name, mapping, gatingSetting, onChange, setGatingSetting, gatingConfigs }) => {
  const dispatch = useDispatch();
  const mappingId = _.get(mapping, "content.id", null);

  const createNewGating = () => {
    var request = {
      uid: shortid(),
      name: 'Untitled Gating',
      enabled: false,
      optional: false,
      target: { id: mappingId, type: "asset" },
      trigger: { type: 'TIME', value: 10 }
    }
  }

  const handleFieldReset = (fieldName, value) => {
    const field = getFieldSelector(mapping, fieldName);
    if (!field) {
      return;
    }

    const request = {
      ...field,
      override: false,
      content: value
    }

    onChange(mapping, request);
  }

  const handleReset = () => {
    const name = _.get(mapping, 'content.asset.name');
    const description = _.get(mapping, 'content.asset.summary');
    var icon = _.get(mapping, 'content.asset.icon');

    if (icon) {
      const id = _.get(icon, 'id');
      const type = _.get(icon, 'type');
      const url = _.get(icon, 'key');

      icon = {
        id: id,
        type: type,
        url: url
      }
    }

    handleFieldReset("name", name);
    handleFieldReset("description", description);
    handleFieldReset("icon", icon);
  }

  return (
    <div className={cx(styles.wrapperContainer, { [styles.expandContainer]: gatingSetting })}>
      <div className={cx(styles.header, { [styles.showHeader]: gatingSetting }, { [styles.hideHeader]: !gatingSetting })}>
        <div className={styles.actions}>
          <span className={styles.backButton} onClick={() => setGatingSetting(false)}>
            <i className={cx('cleverstory-back')} /> Back
          </span>
          <Button className={styles.addButton} variant='secondary' onClick={createNewGating}>
            <i className={cx('cleverstory-plus')} />
            New Gating
          </Button>
        </div>
        <div className={styles.content}>
          <span className={styles.title}>
            Asset Gating
          </span>
          <span className={styles.subTitle}>
            Gating helps generate leads and personalize your marketing efforts.
          </span>
        </div>
      </div>
      {mapping &&
        <ContentConfigCard
          name={name}
          icon={icon}
          gatingSetting={gatingSetting}
          setGatingSetting={setGatingSetting}
          gatingConfigs={gatingConfigs}
          mapping={mapping}
          handleReset={handleReset}
        />
      }
    </div>
  )
}

const renderEmptyMessage = () => {
  return (
    <div className={styles.emptyMessageContainer}>
      <div className={styles.emptyMessage}>
        <video className={styles.emptyImage} loop autoPlay playsInline muted>
          <source src="/images/Blackhole.webm" type="video/webm" />
          <source src="/images/Blackhole.mp4" type="video/mp4" />
        </video>
        <div className={styles.errorMessageContent}>
          <div className={styles.errorMessageTitle}>
            <span>Do<br /> you believe in</span>
            <span>Black<br /> Holes?</span>
          </div>
          <div className={styles.errorMessageSubText}>
            <span>You better do, because nothing<br /> else explains this empty screen.<br /></span>
            <span>...That or you haven’t added <br /> anything here yet.</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContentView;